import { Label, PolarRadiusAxis, RadialBar, RadialBarChart } from 'recharts'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/shared/components/ui/chart'
import { Skeleton } from '@/shared/components/ui/skeleton'

interface SolicitudesEstadoChartProps {
  data: Record<string, number> | undefined
  isLoading?: boolean
}

const chartConfig = {
  registrado: {
    label: 'Registrado',
    color: '#0d9488',
  },
  pendiente: {
    label: 'Pendiente',
    color: '#5eead4',
  },
} satisfies ChartConfig

export function SolicitudesEstadoChart({ data, isLoading }: SolicitudesEstadoChartProps) {
  if (isLoading) {
    return (
      <Card className="flex flex-col border border-gray-300 dark:border-gray-700">
        <CardHeader className="items-center pb-0">
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-32" />
        </CardHeader>
        <CardContent className="flex flex-1 items-center pb-0">
          <Skeleton className="mx-auto aspect-square w-full max-w-[250px] rounded-full" />
        </CardContent>
      </Card>
    )
  }

  const registrado = data?.['Registrado'] || data?.['Completado'] || 0
  const pendiente = data?.['Pendiente'] || 0
  const total = registrado + pendiente

  const chartData = [{ registrado, pendiente }]

  return (
    <Card className="flex flex-col border border-gray-300 dark:border-gray-700">
      <CardHeader className="items-center pb-0">
        <CardTitle className="text-base">Estado De Solicitudes</CardTitle>
      </CardHeader>
      <CardContent className="flex-1 p-2 pb-0">
        <ChartContainer
          config={chartConfig}
          className="!aspect-auto w-full h-[350px]"
        >
          <RadialBarChart
            data={chartData}
            endAngle={180}
            innerRadius="40%"
            outerRadius="100%"
          >
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel />}
            />
            <PolarRadiusAxis tick={false} tickLine={false} axisLine={false}>
              <Label
                content={({ viewBox }) => {
                  if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                    return (
                      <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle">
                        <tspan
                          x={viewBox.cx}
                          y={(viewBox.cy || 0) - 12}
                          className="fill-foreground text-xl font-bold"
                        >
                          {total.toLocaleString()}
                        </tspan>
                        <tspan
                          x={viewBox.cx}
                          y={(viewBox.cy || 0) + 4}
                          className="fill-muted-foreground text-xs"
                        >
                          Total
                        </tspan>
                      </text>
                    )
                  }
                }}
              />
            </PolarRadiusAxis>
            <RadialBar
              dataKey="pendiente"
              stackId="a"
              cornerRadius={5}
              fill="#5eead4"
              className="stroke-transparent stroke-2"
            />
            <RadialBar
              dataKey="registrado"
              fill="#0d9488"
              stackId="a"
              cornerRadius={5}
              className="stroke-transparent stroke-2"
            />
          </RadialBarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}
